module.exports = __webpack_public_path__ + "static/media/ISO14604_14000096_001.02b80c7d.png";